import { api, apiFetch, HttpError } from "./client";

export interface UploadSummary {
  flights: number;
  imports: number;
  ready_flights: number;
}

export interface RecentImport {
  id: number;
  flight_id: number | null;
  source_filename: string | null;
  status: string;
  created_at: string;
}

export interface UploadMetaOut {
  summary: UploadSummary;
  recent_imports: RecentImport[];
}

export interface ReplayUploadOut {
  upload_id: number | null;
  flight_id: number | null;
  status: string;
  message: string;
  username: string;
  replay_id: string | null;
  session_name: string | null;
  title: string | null;
}

export function getUploadMeta() {
  return api.get<UploadMetaOut>("/api/flights/upload-meta");
}

export async function uploadReplay(file: File): Promise<ReplayUploadOut> {
  const form = new FormData();
  form.append("replay_file", file);
  const response = await fetch("/api/replays/upload", {
    method: "POST",
    body: form,
    credentials: "include",
  });
  const isJson = response.headers.get("content-type")?.includes("application/json");
  const payload = isJson ? await response.json().catch(() => null) : null;
  if (!response.ok) {
    throw new HttpError(
      response.status,
      formatUploadError(payload, response.status),
    );
  }
  return payload as ReplayUploadOut;
}

function formatUploadError(payload: unknown, statusCode: number): string {
  if (payload && typeof payload === "object") {
    const detail = (payload as { detail?: unknown }).detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      const messages = detail
        .map((item) => {
          if (item && typeof item === "object" && "msg" in item) {
            return String((item as { msg: unknown }).msg);
          }
          return typeof item === "string" ? item : null;
        })
        .filter((value): value is string => Boolean(value));
      if (messages.length) return messages.join("; ");
    }
  }
  return `Upload failed (status ${statusCode})`;
}

// Re-export for isolated callers
export { apiFetch };
